import { ReactNode } from "react";
import { Box, SxProps } from "@mui/material";
import ModalControl from "./ModalControl";

type ModalContentWithControlProps = {
  children: ReactNode;
  onToggleContent?: () => void;
  showContent?: boolean;
  hideControl?: boolean;
  hideToggleButton?: boolean;
  onClose?: () => void;
  containerSx?: SxProps;
  controlSx?: SxProps;
  contentSx?: SxProps;
  open?: boolean;
};

export default function ModalContentWithControl({
  children,
  onToggleContent,
  showContent,
  hideControl,
  hideToggleButton,
  onClose,
  containerSx,
  controlSx,
  contentSx,
  open
}: ModalContentWithControlProps) {
  if (!open) return null;

  function handleToggleView() {
    onToggleContent?.();
  }

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        background: "#344054",
        p: "1rem",
        pointerEvents: "auto",
        ...(!showContent && {
          background: "transparent",
          pointerEvents: "none"
        }),
        ...containerSx
      }}
      className='modal'
    >
      {/* Modal Controls */}
      {!hideControl && (
        <ModalControl
          currentView={`Switch to ${showContent ? "Map" : "Media"}`}
          hideClose={!showContent}
          hideToggleButton={hideToggleButton}
          onToggleView={handleToggleView}
          onClose={onClose}
          sx={{ ...controlSx, width: 'auto', paddingBlock: "1rem", position: "absolute", top: 0, right: 0, zIndex: 12 }}
        />
      )}

      {/* Just hide the content so that when toggling back, instead of refetching media, losing video/audio play and pdf progress*/}
      <Box
        sx={{
          width: "100%",
          height: "100%",
          maxHeight: "calc(100dvh - 10rem)",
          display: showContent ? "block" : "none",
          padding: "1.25rem",
          overflowY: "auto",
          ...contentSx
        }}
        className='modal-content scroller'
      >
        {children}
      </Box>
    </Box>
  );
}
